import {gsap, Flip} from "../LibrariesImport";
export default class BlockSpecialOffer {
	static init() {

		let blocks = document.querySelectorAll('.block-special-offer');

		blocks.forEach( (block) => {
			const swiper = block.querySelector(".swiper");
			const prev = block.querySelector(".swiper-custom-button-prev");
			const next = block.querySelector(".swiper-custom-button-next");
			const swiperElement = new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				centeredSlides: true,
				spaceBetween: 20,
				speed: 600,
				navigation: {
					prevEl: prev,
					nextEl: next
				}
			});

		});
	}

	static removeClassByPrefix(node, prefix) {
		const regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
		node.className = node.className.replace(regx, '');
		return node;
	}

}
